export default "__VITE_ASSET__BhDtajqX__"